import { z } from "zod";

// ── Notification Type ──

export const NotificationTypeSchema = z.enum([
    "welcome",
    "new_list",
    "invitation_accepted",
    "cookie_expiry",
    "enrichment_started",
    "enrichment_completed",
    "enrichment_failed",
    // #717: a client commented on a list (to the Invyo admins), and Invyo
    // answered in a list's thread (to the licence's users).
    "list_feedback",
    "feedback_reply",
]);
export type NotificationType = z.infer<typeof NotificationTypeSchema>;

// ── Notification Response ──

export const NotificationResponseSchema = z.object({
    id: z.uuid(),
    type: NotificationTypeSchema,
    title: z.string(),
    content: z.string(),
    redirection_url: z.string().nullable(),
    read: z.boolean(),
    created_at: z.string(),
});
export type NotificationResponse = z.infer<typeof NotificationResponseSchema>;

// ── Paginated List Response ──

export const NotificationListResponseSchema = z.object({
    success: z.boolean(),
    data: z.array(NotificationResponseSchema),
    has_more: z.boolean(),
});
export type NotificationListResponse = z.infer<typeof NotificationListResponseSchema>;

// ── Unread Count Response ──

export const UnreadCountResponseSchema = z.object({
    success: z.boolean(),
    data: z.object({ count: z.number().int() }),
});
export type UnreadCountResponse = z.infer<typeof UnreadCountResponseSchema>;
